import intl from 'preact-i18n';
import definition from './intl.json';

import $SymbolLookup from './components/symbol-lookup';
import $StockTableWrapper from './components/stock-table-wrapper';
import $StockWidgetTable from './components/stock-widget-table';
import $LastUpdated from './components/last-updated';

function intlWrap(Child) {
	return intl(Child, { scope: 'finance-blocks', definition });
}

export const SymbolLookup = intlWrap($SymbolLookup);
export const StockTableWrapper = intlWrap($StockTableWrapper);
export const StockWidgetTable = intlWrap($StockWidgetTable);
export const LastUpdated = intlWrap($LastUpdated);
